import React from 'react'
import {
  IconTrash,
  IconMovie,
  IconVideo,
} from '@tabler/icons-react'
import { Link } from 'react-router-dom'
import Breadcrumb from '../../components/common/Breadcrumb'

export default function FileMedia() {

  const fileMediaList = [
    {
      icon: IconMovie,
      name: "Sample2016.mkv",
      type: "mkv",
      size: "720MB",
      date: "Nov 02, 2017",
    },
    {
      icon: IconVideo,
      name: "Jee Le Zara Song.mp4",
      type: "mp4",
      size: "32MB",
      date: "Dec 15, 2017",
    },
    {
      icon: IconMovie,
      name: "Sample2016.mkv",
      type: "mkv",
      size: "720MB",
      date: "Nov 02, 2017",
    },
    {
      icon: IconMovie,
      name: "Sample2016.mkv",
      type: "mkv",
      size: "720MB",
      date: "Nov 02, 2017",
    },
    {
      icon: IconVideo,
      name: "Jee Le Zara Song.mp4",
      type: "mp4",
      size: "32MB",
      date: "Dec 15, 2017",
    },
    {
      icon: IconVideo,
      name: "Jee Le Zara Song.mp4",
      type: "mp4",
      size: "32MB",
      date: "Dec 15, 2017",
    },
    {
      icon: IconMovie,
      name: "Sample2016.mkv",
      type: "mkv",
      size: "720MB",
      date: "Nov 02, 2017",
    },
    {
      icon: IconVideo,
      name: "Jee Le Zara Song.mp4",
      type: "mp4",
      size: "32MB",
      date: "Dec 15, 2017",
    },
  ]

  return (
    <>
      <Breadcrumb title="File Media" path="File Manager / File Media" />
      <div className='grid xl:grid-cols-4 md:grid-cols-3 sm:grid-cols-2 lg:gap-30 gap-15'>
        {fileMediaList.map((item, key) => (
          <Link to="#" key={key} className='bg-bg-dark shadow-light rounded-lg relative group'>
            <div className='py-15 px-10 min-h-[130px] flex items-center justify-center'>
              <item.icon
                className={`w-[40px] h-[40px] stroke-[1.5] ${item.type === 'mkv' ? 'text-blue' : item.type === 'mp4' ? 'text-yellow' : ''}`}
              />
            </div>
            <div className='border-t border-border p-10'>
              <p className="mb-5 text-text-primary">{item.name}</p>
              <small className='text-blue flex items-center justify-between gap-10'>
                Size: {item.size}
                <span className="text-text-secondary">{item.date}</span>
              </small>
            </div>
            <button className='bg-danger rounded-[4px] px-10 py-[8px] absolute right-10 top-10 z-[1] hidden group-hover:block'>
              <IconTrash className='text-white w-[18px] h-[18px] stroke-[1.5]' />
            </button>
          </Link>
        ))}
      </div>
    </>
  )
}
